export default __webpack_public_path__ + "static/media/Real-estate.25098175.png";